module.exports = __webpack_public_path__ + "static/media/logo@3x.9b5b726c.jpg";